module.exports = __webpack_public_path__ + "favicon-16x16.dd949bf3.png";